import "@src/shared/utils/transcribe/mediaRecorder.init";

import { useLocation } from "react-router-dom";

import { usePatientIdFromParams } from "../../../application";
import type { PatientDetailTabV2 } from "../../../ui/components/v2";
import { PatientDetailPageV2 } from "../../../ui/pages/v2";

function tabFromPathname(pathname: string): PatientDetailTabV2 {
  return pathname.endsWith("/visits") ? "visits" : "agenda";
}

export function PatientDetailV2Route() {
  const patientId = usePatientIdFromParams();
  const { pathname } = useLocation();

  return (
    <PatientDetailPageV2
      patientId={patientId}
      activeTab={tabFromPathname(pathname)}
    />
  );
}
